import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { DuotoneFilters } from '@/components/generals/duotone-filters'
import { Footer } from '@/components/generals/footer'
import { Header } from '@/components/generals/header'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only z-[60] bg-tone-accent px-4 py-3 font-semibold text-tone-accent-fg focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Kalo te përmbajtja
            </a>

            <DuotoneFilters />
            <Header />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
